<template>
    <section class="title-panel grid cols-3_1 --mobile">
        <div class="title-panel__text">
            <h3>{{ title }}</h3>
            <p><slot /></p>
        </div>
        <div v-if="this.showChange"
             class="title-panel__actions --end">
            <hh-btn :text="buttonTextActual" track-operation-state @click="$emit('click')" />
        </div>
    </section>
</template>

<script>

import ResourcesHelper from '@/components/resources-helper'

export default {
    mixins: [
        ResourcesHelper,
    ],

    props: {

        /**
         * @type {string|{}}
         */
        title: {
            type: String,
            required: true,
        },

        /**
         * @type {string|{}}
         */
        buttonText: {
            type: String,
            default: '',
        },

        /**
         * @type {boolean|{}}
         */
        showChange: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        /**
         * @returns {String}
         */
        buttonTextActual() {
            return this.buttonText || this.commonResources.change
        },
    },
}

</script>

<style lang="scss">

.title-panel {
    padding-bottom: 0.5rem;

    h3 {
        margin-bottom: 0.2rem;
    }

    p {
        margin-bottom: 0;
    }
}

</style>
